import { useApi } from '@/shared/api/http';
import type { StatusResponse, EmptyResponse } from '@/shared/model/types/http';
import type {
  IUser,
  IUserSelfResponse,
  IUserGalleryResponse,
  IUnreadMessages,
  IUpdateSelfPayload,
  IUpdatePasswordPayload,
  IUpdateNotificationsPayload,
  IUpdateGalleryPayload,
  IUpdateScheduleTypePayload,
  IAvatarPayload,
} from '@/entities/user/model/types/user';

export const useUserService = () => {
  const api = useApi();

  const getUser = async (token?: string) => {
    const options = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    return await api.get<IUser>('self/', options);
  };

  const getMyUnreadMessagesNumber = async () => {
    return await api.get<IUnreadMessages>('self/non-listen-messages/');
  };

  const updateMySelf = async (dataReq: IUpdateSelfPayload) => {
    return await api.patch<IUserSelfResponse>('self', dataReq);
  };

  const updatePassword = async (dataReq: IUpdatePasswordPayload) => {
    return await api.patch('self/change-password', dataReq);
  };

  const updateNotifications = async (dataReq: IUpdateNotificationsPayload) => {
    return await api.patch<StatusResponse>('self/notifications', dataReq);
  };

  const updateGallery = async (dataReq: IUpdateGalleryPayload) => {
    return await api.patch<IUserGalleryResponse>('self/gallery', dataReq);
  };

  const updateDefaultScheduleType = async (dataReq: IUpdateScheduleTypePayload) => {
    return await api.patch<StatusResponse>('self/update-default-schedule-type', dataReq);
  };

  const uploadAvatar = async (dataReq: IAvatarPayload) => {
    return await api.patch<IUserSelfResponse>('self/update-avatar', dataReq);
  };

  const deleteGalleryItem = async () => {
    return await api.delete('self/gallery');
  };

  const deleteAvatar = async () => {
    return await api.delete<EmptyResponse>('self/delete-avatar');
  };

  return {
    getUser,
    getMyUnreadMessagesNumber,
    updateMySelf,
    updatePassword,
    updateNotifications,
    updateGallery,
    updateDefaultScheduleType,
    uploadAvatar,
    deleteGalleryItem,
    deleteAvatar,
  };
};
